import dynamic from "next/dynamic";
import { type Maybe } from "~/__generated__/graphql";
import NotImplemented from "~/slices/NotImplemented";

export const components = {
  Text: dynamic(() => import("~/components/form-builder/Text")),
  Select: dynamic(() => import("~/components/form-builder/Select")),
  Group: dynamic(() => import("~/components/form-builder/Group")),
  Checkbox: dynamic(() => import("~/components/form-builder/Checkbox")),
  Note: dynamic(() => import("~/components/form-builder/Note")),
  Email: dynamic(() => import("~/components/form-builder/Email")),
};

export function FormFieldRenderer({
  slices,
  fieldGroupKey,
  ...rest
}: {
  slices?: Maybe<Maybe<{ fieldGroupName: string; [key: string]: unknown }>[]>;
  fieldGroupKey: string;
} & Record<string, unknown>) {
  return (
    <>
      {slices?.map((slice, index) => {
        const type = slice?.fieldGroupName?.replace(fieldGroupKey, "");
        const Comp =
          components[type as keyof typeof components] || NotImplemented;

        const key = `${type}-${index}`;

        if (!slice) return null;

        return (
          <Comp key={key} {...(slice as Record<string, unknown>)} {...rest} />
        );
      })}
    </>
  );
}
